import { render, staticRenderFns } from "./oilCardTrajectory.vue?vue&type=template&id=5020f196&"
import script from "./oilCardTrajectory.vue?vue&type=script&lang=js&"
export * from "./oilCardTrajectory.vue?vue&type=script&lang=js&"
import style0 from "./oilCardTrajectory.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports